export default [
  {
    path: "affiliate",
    name: "adminClientAffiliate",
    redirect: { name: "adminClientAffiliateOverview" },
    component: () => import("@/views/admin/clients/client/affiliate/index.vue"),
    props: () => ({
      routes: require("./menu").affiliateAccountTabigation
    }),
    children: [
      {
        path: "overview",
        name: "adminClientAffiliateOverview",
        component: () =>
          import("@/views/admin/clients/client/affiliate/overview/index.vue"),
        meta: {
          backTo: "_.overview"
        }
      },
      {
        path: "commissions",
        name: "adminClientAffiliateCommissions",
        component: () =>
          import(
            "@/views/admin/clients/client/affiliate/commissions/index.vue"
          ),
        meta: {
          backTo: "_.commissions"
        }
      },
      {
        path: "payouts",
        name: "adminClientAffiliatePayouts",
        component: () =>
          import("@/views/admin/clients/client/affiliate/payouts/index.vue"),
        meta: {
          backTo: "_.payouts"
        }
      },
      {
        path: "settings",
        name: "adminClientAffiliateSettings",
        component: () =>
          import("@/views/admin/clients/client/affiliate/settings/index.vue"),
        meta: {
          backTo: "_.settings"
        }
      }
    ]
  }
];
